"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const core_1 = require("@zettel/core");
const DefaultRenderBlock_1 = __importDefault(require("./DefaultRenderBlock"));
const EditorChildren_1 = __importDefault(require("./EditorChildren"));
const editorStyles = {
    whiteSpace: 'pre-wrap',
    WebkitUserModify: 'read-write-plaintext-only',
    WebkitLineBreak: 'after-white-space',
    overflowWrap: 'break-word',
    userSelect: 'text',
    outline: 'none'
};
const Editor = (props) => {
    const { editorState: _editorState, onChange: _onChange, readOnly, htmlAttrs, renderTextFragment, renderStyle, renderBlock = DefaultRenderBlock_1.default, renderChildren, } = props;
    const onChange = (args) => _onChange(args);
    const ref = react_1.useRef(null);
    const [isComposing, setComposing] = react_1.useState(false);
    const editorState = _editorState;
    let handlerProps = {};
    if (!readOnly) {
        handlerProps = {
            onCompositionStart: () => setComposing(true),
            onCompositionEnd: () => {
                onChange(core_1.onSelectionChange(editorState));
                setComposing(false);
            },
            onSelect: () => {
                const newEditorState = core_1.onSelectionChange(editorState);
                const { start, end } = editorState;
                if (newEditorState != null &&
                    (start !== newEditorState.start || end !== newEditorState.end)
                    && !isComposing) {
                    onChange(newEditorState);
                }
            },
            onKeyDown: (event) => {
                let handled = null;
                if (props.onKeyDown != null) {
                    handled = props.onKeyDown(event);
                }
                if (handled == null) {
                    handled = core_1.onKeyDown(editorState, event.nativeEvent);
                }
                if (handled != null) {
                    event.preventDefault();
                    onChange(core_1.onSelectionChange(editorState));
                    onChange(handled);
                }
            }
        };
    }
    react_1.useLayoutEffect(() => {
        const container = ref.current;
        if (container != null && !isComposing && !readOnly) {
            core_1.setDomSelection(editorState, container);
        }
    });
    react_1.useLayoutEffect(() => {
        const el = ref != null ? ref.current : null;
        if (el != null && !readOnly) {
            const beforeinput = (event) => {
                const newEditorState = core_1.onBeforeInput(editorState, event);
                if (newEditorState != null) {
                    onChange(newEditorState);
                }
            };
            el.addEventListener('beforeinput', beforeinput);
            return () => {
                el.removeEventListener('beforeinput', beforeinput);
            };
        }
    }, [ref.current, editorState, readOnly]);
    const divProps = Object.assign(Object.assign({}, htmlAttrs), { style: readOnly ? {} : Object.assign({}, editorStyles), contentEditable: readOnly ? false : true });
    const viewState = props.viewState || react_1.useMemo(() => core_1.createViewState(editorState.list), [isComposing || editorState]);
    const children = React.createElement(EditorChildren_1.default, { readOnly: readOnly, blocks: viewState.blocks, renderBlock: renderBlock, renderTextFragment: renderTextFragment, renderStyle: renderStyle, renderChildren: renderChildren });
    return (React.createElement("div", Object.assign({ suppressContentEditableWarning: true, role: "textbox", autoCorrect: 'off', ref: ref }, handlerProps, divProps), children));
};
exports.default = Editor;
//# sourceMappingURL=Editor.js.map